/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* istanbul ignore file */
import jwtDecode from 'jwt-decode'

// App.js registers the refresher (needs MSAL instance + recoil setters); the API selector calls it.
let refresher = null
let inFlightRefresh = null

const setTokenRefresher = (refreshFn) => {
  refresher = refreshFn
}

// Concurrent API calls share one refresh; resolves to the new API token or null on failure.
const refreshAppToken = () => {
  if (!refresher) return Promise.resolve(null)
  if (!inFlightRefresh) {
    inFlightRefresh = Promise.resolve()
      .then(() => refresher())
      .catch(() => null)
      .finally(() => {
        inFlightRefresh = null
      })
  }
  return inFlightRefresh
}

const isJwtExpired = (token, skewSeconds = 60) => {
  try {
    const exp = jwtDecode(token)?.exp
    return Boolean(exp) && exp * 1000 - skewSeconds * 1000 < Date.now()
  } catch (_) {
    return false
  }
}

export { setTokenRefresher, refreshAppToken, isJwtExpired }
